<script>
import Layout from "@/router/layouts/auth";
import Languages from "@/components/widgets/languages";
import EcosystemUserMenu from "@/components/widgets/ecosystem-user-menu";
import TripteevPlanCard from "@/components/widgets/tripteev-plan-card";
import { api } from "@/state/services";

// Tripteev: adesão, fatura pendente, mensalidades e acesso ao portal (visual do Experts)
export default {
  locales: {
    pt: {
      'Back to ecosystem': 'Voltar ao ecossistema',
      'We apologize, we are unable to retrieve the information at this time.': 'Pedimos desculpas, não podemos recuperar as informações neste momento.',
      'Try again': 'Tentar novamente',
      'Activate your Tripteev.': 'Ative seu Tripteev.',
      'Almost there to activate your Tripteev.': 'Falta pouco para ativar seu Tripteev.',
      'My Tripteev': 'Meu Tripteev',
      'Join and enjoy travel and experiences. Membership releases 30 days of access, then keep it active with the monthly fee.': 'Faça sua adesão e aproveite viagens e experiências. A adesão libera 30 dias de acesso e depois você mantém ativo com a mensalidade.',
      'Activation in minutes': 'Ativação em minutos',
      'PIX, card and balance': 'PIX, Cartão e Saldo',
      '30 days per payment': '30 dias por pagamento',
      'CHOOSE YOUR': 'FAÇA SUA',
      'PAY IN ADVANCE YOUR': 'ANTECIPE SUA',
      'RENEW YOUR': 'RENOVE SUA',
      'MEMBERSHIP': 'ADESÃO',
      'MONTHLY FEE': 'MENSALIDADE',
      'Join Tripteev': 'Aderir ao Tripteev',
      'Pay next monthly fee': 'Antecipar mensalidade',
      'Renew monthly fee': 'Renovar mensalidade',
      'There is no Tripteev plan available for you.': 'Não há plano do Tripteev disponível para você.',
      'Secure payment': 'Pagamento seguro',
      'Activation in minutes after payment': 'Ativação em minutos após o pagamento',
      'Releases from': 'Libera de',
      'to': 'a',
      'Membership': 'Adesão',
      'Monthly fee': 'Mensalidade',
      'Invoice': 'Fatura',
      'being activated': 'em ativação',
      'awaiting payment': 'aguardando pagamento',
      'PENDING': 'PENDENTE',
      'PAID': 'PAGO',
      'ACTIVE': 'ATIVO',
      'EXPIRED': 'VENCIDO',
      '30 days': '30 dias',
      'This invoice expires on': 'Esta fatura vence em',
      'Paid': 'Pago',
      'of': 'de',
      'This invoice has a partial payment. Complete the payment to continue.': 'Esta fatura tem pagamento parcial. Complete o pagamento para continuar.',
      'We have received your payment and are activating your access. This takes a few moments.': 'Recebemos o seu pagamento e estamos ativando o seu acesso. Isso leva poucos instantes.',
      'Pay now': 'Pagar agora',
      'Cancel invoice': 'Cancelar fatura',
      'Your Tripteev': 'Seu Tripteev',
      'Valid until': 'Válido até',
      'days left': 'dias restantes',
      'or': 'ou',
      'Sign in with your Nexteev username and password': 'Acesse com seu usuário e senha Nexteev',
      'Go to': 'Ir para',
      'Access the Tripteev portal': 'Acessar o portal Tripteev',
      'Your access expires on': 'Seu acesso vence em',
      'Pay the next monthly fee in advance to keep it active.': 'Antecipe a próxima mensalidade para continuar ativo.',
      'Next monthly fee already paid until': 'Próxima mensalidade já paga até',
      'You can pay the next one when the current period ends.': 'Você poderá antecipar a próxima quando o período atual terminar.',
      'Your access expired on': 'Seu acesso venceu em',
      'Pay the monthly fee to reactivate it for 30 days from the payment date.': 'Pague a mensalidade para reativar por 30 dias a partir da data do pagamento.',
      'Invoice history': 'Histórico de faturas',
      'Date': 'Data',
      'Type': 'Tipo',
      'Period': 'Período',
      'Total': 'Total',
      'Status': 'Status',
      'Pending': 'Pendente',
      'Approved': 'Pago',
      'Frequently asked questions': 'Perguntas frequentes',
      'How long does it take to activate my access?': 'Em quanto tempo meu acesso é ativado?',
      'Right after the payment is confirmed. With PIX and credit card, activation happens within a few minutes.': 'Logo após a confirmação do pagamento. No PIX e no cartão a ativação acontece em poucos minutos.',
      'How long does each payment last?': 'Quanto tempo vale cada pagamento?',
      'Membership and each monthly fee release 30 days of access. If you pay in advance, the new period starts the day after the current one ends.': 'A adesão e cada mensalidade liberam 30 dias de acesso. Se pagar antecipado, o novo período começa no dia seguinte ao fim do atual.',
      'What if I pay after the due date?': 'E se eu pagar depois do vencimento?',
      'Your access is reactivated for 30 days from the payment date. Membership is not charged again.': 'Seu acesso é reativado por 30 dias a partir da data do pagamento. A adesão não é cobrada novamente.',
      'I generated the invoice and want to cancel it. What now?': 'Gerei a fatura e quero cancelar. E agora?',
      'While the invoice has no payment, you can cancel it on this page. It expires automatically in 3 days.': 'Enquanto a fatura não tiver pagamento, você pode cancelá-la nesta página. Ela expira automaticamente em 3 dias.',
      'Your Tripteev access has been activated!': 'Seu acesso ao Tripteev foi ativado!',
    },
    es: {
      'Back to ecosystem': 'Volver al ecosistema',
      'We apologize, we are unable to retrieve the information at this time.': 'Lo sentimos, no podemos recuperar la información en este momento.',
      'Try again': 'Intentar de nuevo',
      'Activate your Tripteev.': 'Activa tu Tripteev.',
      'Almost there to activate your Tripteev.': 'Falta poco para activar tu Tripteev.',
      'My Tripteev': 'Mi Tripteev',
      'Join and enjoy travel and experiences. Membership releases 30 days of access, then keep it active with the monthly fee.': 'Haz tu adhesión y disfruta de viajes y experiencias. La adhesión libera 30 días de acceso y después lo mantienes activo con la mensualidad.',
      'Activation in minutes': 'Activación en minutos',
      'PIX, card and balance': 'PIX, Tarjeta y Saldo',
      '30 days per payment': '30 días por pago',
      'CHOOSE YOUR': 'HAZ TU',
      'PAY IN ADVANCE YOUR': 'ADELANTA TU',
      'RENEW YOUR': 'RENUEVA TU',
      'MEMBERSHIP': 'ADHESIÓN',
      'MONTHLY FEE': 'MENSUALIDAD',
      'Join Tripteev': 'Adherirse a Tripteev',
      'Pay next monthly fee': 'Adelantar mensualidad',
      'Renew monthly fee': 'Renovar mensualidad',
      'There is no Tripteev plan available for you.': 'No hay un plan de Tripteev disponible para ti.',
      'Secure payment': 'Pago seguro',
      'Activation in minutes after payment': 'Activación en minutos después del pago',
      'Releases from': 'Libera del',
      'to': 'al',
      'Membership': 'Adhesión',
      'Monthly fee': 'Mensualidad',
      'Invoice': 'Factura',
      'being activated': 'en activación',
      'awaiting payment': 'en espera de pago',
      'PENDING': 'PENDIENTE',
      'PAID': 'PAGADO',
      'ACTIVE': 'ACTIVO',
      'EXPIRED': 'VENCIDO',
      '30 days': '30 días',
      'This invoice expires on': 'Esta factura vence el',
      'Paid': 'Pagado',
      'of': 'de',
      'This invoice has a partial payment. Complete the payment to continue.': 'Esta factura tiene un pago parcial. Completa el pago para continuar.',
      'We have received your payment and are activating your access. This takes a few moments.': 'Recibimos tu pago y estamos activando tu acceso. Esto tarda unos instantes.',
      'Pay now': 'Pagar ahora',
      'Cancel invoice': 'Cancelar factura',
      'Your Tripteev': 'Tu Tripteev',
      'Valid until': 'Válido hasta',
      'days left': 'días restantes',
      'or': 'o',
      'Sign in with your Nexteev username and password': 'Accede con tu usuario y contraseña de Nexteev',
      'Go to': 'Ir a',
      'Access the Tripteev portal': 'Acceder al portal Tripteev',
      'Your access expires on': 'Tu acceso vence el',
      'Pay the next monthly fee in advance to keep it active.': 'Adelanta la próxima mensualidad para seguir activo.',
      'Next monthly fee already paid until': 'Próxima mensualidad ya pagada hasta',
      'You can pay the next one when the current period ends.': 'Podrás adelantar la próxima cuando termine el período actual.',
      'Your access expired on': 'Tu acceso venció el',
      'Pay the monthly fee to reactivate it for 30 days from the payment date.': 'Paga la mensualidad para reactivarlo por 30 días desde la fecha de pago.',
      'Invoice history': 'Historial de facturas',
      'Date': 'Fecha',
      'Type': 'Tipo',
      'Period': 'Período',
      'Total': 'Total',
      'Status': 'Estado',
      'Pending': 'Pendiente',
      'Approved': 'Pagado',
      'Frequently asked questions': 'Preguntas frecuentes',
      'How long does it take to activate my access?': '¿Cuánto tarda en activarse mi acceso?',
      'Right after the payment is confirmed. With PIX and credit card, activation happens within a few minutes.': 'Justo después de confirmarse el pago. Con PIX y tarjeta la activación ocurre en pocos minutos.',
      'How long does each payment last?': '¿Cuánto dura cada pago?',
      'Membership and each monthly fee release 30 days of access. If you pay in advance, the new period starts the day after the current one ends.': 'La adhesión y cada mensualidad liberan 30 días de acceso. Si pagas por adelantado, el nuevo período comienza el día siguiente al fin del actual.',
      'What if I pay after the due date?': '¿Y si pago después del vencimiento?',
      'Your access is reactivated for 30 days from the payment date. Membership is not charged again.': 'Tu acceso se reactiva por 30 días desde la fecha de pago. La adhesión no se cobra de nuevo.',
      'I generated the invoice and want to cancel it. What now?': 'Generé la factura y quiero cancelarla. ¿Y ahora?',
      'While the invoice has no payment, you can cancel it on this page. It expires automatically in 3 days.': 'Mientras la factura no tenga pago, puedes cancelarla en esta página. Vence automáticamente en 3 días.',
      'Your Tripteev access has been activated!': '¡Tu acceso a Tripteev fue activado!',
    },
  },
  components: {
    Layout,
    Languages,
    EcosystemUserMenu,
    TripteevPlanCard,
  },
  data() {
    return {
      logo: require("@/assets/images/brands/tripteev.svg"),
      loading: true,
      errored: false,

      situation: null,
      current: null,
      next: null,
      pending: null,
      history: [],


      timer: null,
    };
  },
  computed: {
    // URL do portal Tripteev com o token do usuário logado
    portal() {
      const token = localStorage.getItem("token");
      return "https://portal.tripteev.com/entrar/token/" + token;
    },
    // Ainda sem acesso pago: tela de chamada (igual ao Experts sem plano)
    isIntro() {
      return this.situation == "no_adhesion" || this.situation == "adhesion_pending" || (this.situation == "processing" && this.pending && this.pending.type == "adhesion");
    },
    hasPartial() {
      return this.pending && parseFloat(this.pending.paid || 0) > 0;
    },
    // Card de cobrança disponível (adesão, antecipar ou renovar)
    showCharge() {
      return !this.pending && this.next && ["no_adhesion", "active", "expired"].includes(this.situation);
    },
    pillPrefix() {
      if (this.situation == "active") {
        return this.t("PAY IN ADVANCE YOUR");
      }
      if (this.situation == "expired") {
        return this.t("RENEW YOUR");
      }
      return this.t("CHOOSE YOUR");
    },
    action() {
      if (this.situation == "active") {
        return this.t("Pay next monthly fee");
      }
      if (this.situation == "expired") {
        return this.t("Renew monthly fee");
      }
      return this.t("Join Tripteev");
    },
  },
  methods: {
    load(silent) {
      if (!silent) {
        this.loading = true;
      }
      this.errored = false;

      const before = this.situation;

      return Promise.all([api.get("tripteev"), api.get("tripteev/history")])
        .then(([current, history]) => {
          if (current.data.status == "success") {
            this.situation = current.data.situation;
            this.current = current.data.current;
            this.next = current.data.next;
            this.pending = current.data.pending;

            // Fatura em aberto que foi aprovada durante a consulta automática
            const waiting = ["adhesion_pending", "monthly_pending", "processing"];
            if (silent && waiting.includes(before) && !waiting.includes(this.situation) && this.current.status == "active") {
              this.$toast.success(this.t("Your Tripteev access has been activated!"));
            }
          }
          if (history.data.status == "success") {
            this.history = history.data.list;
          }
          this.schedule();
        })
        .catch(() => {
          if (silent) {
            this.schedule();
          } else {
            this.errored = true;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // Com fatura em aberto: a cada 5s na ativação e a cada 15s aguardando o pagamento
    schedule() {
      clearTimeout(this.timer);
      if (this.pending) {
        const delay = this.pending.status == "processing" ? 5000 : 15000;
        this.timer = setTimeout(() => this.load(true), delay);
      }
    },
    showConfirm() {
      this.$router.push("/tripteev/confirm");
    },
    typeLabel(type) {
      return type == "adhesion" ? this.t("Membership") : this.t("Monthly fee");
    },
    statusLabel(status) {
      return status == "approved" ? this.t("Approved") : this.t("Pending");
    },
  },
  mounted() {
    this.load();
  },
  beforeDestroy() {
    clearTimeout(this.timer);
  },
};
</script>

<template>
  <Layout>
    <div class="ecosystem">
      <header class="ecosystem-header">
        <router-link to="/ecosystem" class="ecosystem-back">
          <i class="bx bx-left-arrow-alt" aria-hidden="true"></i> {{ t('Back to ecosystem') }}
        </router-link>
        <div class="ecosystem-actions">
          <Languages type="right"></Languages>
          <EcosystemUserMenu></EcosystemUserMenu>
        </div>
      </header>

      <main class="ecosystem-main">
        <div v-if="loading" class="text-center py-5">
          <b-spinner variant="default" role="status"></b-spinner>
        </div>
        <div v-else-if="errored" class="text-center py-5">
          <p>{{ t('We apologize, we are unable to retrieve the information at this time.') }}</p>
          <button class="btn btn-default" v-on:click="load()">{{ t('Try again') }}</button>
        </div>
        <div v-else class="tripteev">
          <!-- Chamada -->
          <div v-if="isIntro" class="tripteev-intro">
            <img :src="logo" alt="Tripteev" class="tripteev-logo" />
            <h1 class="tripteev-title">
              <template v-if="pending">{{ t('Almost there to activate your Tripteev.') }}</template>
              <template v-else>{{ t('Activate your Tripteev.') }}</template>
            </h1>
            <template v-if="!pending">
              <p class="tripteev-subtitle">
                {{ t('Join and enjoy travel and experiences. Membership releases 30 days of access, then keep it active with the monthly fee.') }}
              </p>
              <ul class="tripteev-highlights">
                <li><i class="bx bx-bolt-circle" aria-hidden="true"></i> {{ t('Activation in minutes') }}</li>
                <li><i class="bx bx-credit-card" aria-hidden="true"></i> {{ t('PIX, card and balance') }}</li>
                <li><i class="bx bx-calendar-check" aria-hidden="true"></i> {{ t('30 days per payment') }}</li>
              </ul>
            </template>
          </div>
          <div v-else class="tripteev-intro">
            <img :src="logo" alt="Tripteev" class="tripteev-logo" />
            <h1 class="tripteev-title">{{ t('My Tripteev') }}</h1>
          </div>

          <!-- Próximo do vencimento -->
          <div v-if="situation == 'active' && current.days_left <= 5" class="alert alert-warning tripteev-box p-3">
            {{ t('Your access expires on') }} {{ current.due_date }}. {{ t('Pay the next monthly fee in advance to keep it active.') }}
          </div>

          <!-- Fatura pendente -->
          <div v-if="pending" class="tripteev-box">
            <div class="d-flex justify-content-between align-items-start mb-2">
              <h5 class="mb-0">{{ t('Invoice') }} {{ pending.status == 'processing' ? t('being activated') : t('awaiting payment') }}</h5>
              <span v-if="pending.status == 'processing'" class="badge badge-soft-success font-size-12">{{ t('PAID') }}</span>
              <span v-else class="badge badge-soft-danger font-size-12">{{ t('PENDING') }}</span>
            </div>
            <p class="mb-1"><strong>{{ typeLabel(pending.type) }}</strong> · {{ t('30 days') }}</p>
            <h3 class="text-default mb-2">{{ pending.total | currency }}</h3>
            <template v-if="pending.status == 'processing'">
              <p class="text-muted mb-0">
                <b-spinner small class="mr-1 align-middle" variant="default" role="status"></b-spinner>
                {{ t('We have received your payment and are activating your access. This takes a few moments.') }}
              </p>
            </template>
            <template v-else>
              <template v-if="hasPartial">
                <p class="mb-1">{{ t('Paid') }} <strong>{{ pending.paid | currency }}</strong> {{ t('of') }} <strong>{{ pending.total | currency }}</strong></p>
                <p class="text-muted">{{ t('This invoice has a partial payment. Complete the payment to continue.') }}</p>
              </template>
              <p v-else class="text-muted">{{ t('This invoice expires on') }} {{ pending.expires }}.</p>
              <router-link :to="'/tripteev/order/' + pending.order.id" class="btn btn-default btn-lg btn-block text-uppercase mb-3">
                {{ t('Pay now') }}
              </router-link>
              <router-link v-if="!hasPartial" to="/tripteev/cancel" class="btn btn-outline-danger btn-lg btn-block text-uppercase">
                {{ t('Cancel invoice') }}
              </router-link>
            </template>
          </div>

          <!-- Acesso ativo -->
          <div v-if="situation == 'active' || situation == 'advanced' || (situation == 'monthly_pending' && current.status == 'active')" class="tripteev-box">
            <div class="d-flex justify-content-between align-items-start mb-2">
              <h5 class="mb-0">{{ t('Your Tripteev') }}</h5>
              <span class="badge badge-soft-success font-size-12">{{ t('ACTIVE') }}</span>
            </div>
            <p class="text-muted">{{ t('Valid until') }} {{ current.due_date }} ({{ current.days_left }} {{ t('days left') }}).</p>
            <a :href="portal" target="_blank" rel="noopener" class="btn btn-default btn-lg btn-block text-uppercase">
              {{ t('Access the Tripteev portal') }} <i class="bx bx-link-external ml-1 align-middle" aria-hidden="true"></i>
            </a>
            <p class="text-center text-muted my-2">{{ t('or') }}</p>
            <p class="text-center mb-2">{{ t('Sign in with your Nexteev username and password') }}</p>
            <a href="https://portal.tripteev.com" target="_blank" rel="noopener" class="btn btn-outline-default btn-lg btn-block">
              {{ t('Go to') }} portal.tripteev.com <i class="bx bx-link-external ml-1 align-middle" aria-hidden="true"></i>
            </a>
            <div v-if="situation == 'advanced'" class="tripteev-note mt-3 mb-0">
              <i class="bx bx-check-circle" aria-hidden="true"></i>
              <span>{{ t('Next monthly fee already paid until') }} {{ current.due_date }}. {{ t('You can pay the next one when the current period ends.') }}</span>
            </div>
          </div>

          <!-- Acesso vencido -->
          <div v-if="situation == 'expired'" class="tripteev-box">
            <div class="d-flex justify-content-between align-items-start mb-2">
              <h5 class="mb-0">{{ t('Your Tripteev') }}</h5>
              <span class="badge badge-soft-danger font-size-12">{{ t('EXPIRED') }}</span>
            </div>
            <p v-if="current.due_date" class="mb-1">{{ t('Your access expired on') }} {{ current.due_date }}.</p>
            <p class="text-muted mb-0">{{ t('Pay the monthly fee to reactivate it for 30 days from the payment date.') }}</p>
          </div>

          <!-- Cobrança disponível: adesão, antecipar ou renovar -->
          <div v-if="showCharge" class="mt-4">
            <h2 class="tripteev-pill">
              <span>{{ pillPrefix }}</span>
              <strong>{{ next.type == 'adhesion' ? t('MEMBERSHIP') : t('MONTHLY FEE') }}</strong>
            </h2>
            <div class="tripteev-plans is-single">
              <TripteevPlanCard :plan="next" :recommended="false" :action="action" @choose="showConfirm()" />
            </div>
            <p v-if="next.type == 'monthly'" class="text-center text-muted mt-3 mb-0">
              {{ t('Releases from') }} {{ next.date_start }} {{ t('to') }} {{ next.date_end }}
            </p>

          </div>
          <div v-else-if="situation == 'no_adhesion' && !next" class="tripteev-box text-center">
            <p class="mb-0">{{ t('There is no Tripteev plan available for you.') }}</p>
          </div>

          <!-- Histórico -->
          <div v-if="history.length > 0" class="tripteev-box mt-4">
            <h5 class="mb-3">{{ t('Invoice history') }}</h5>
            <div class="table-responsive">
              <table class="table table-sm table-nowrap mb-0">
                <thead class="thead-light">
                  <tr>
                    <th>{{ t('Date') }}</th>
                    <th>{{ t('Type') }}</th>
                    <th>{{ t('Period') }}</th>
                    <th>{{ t('Total') }}</th>
                    <th>{{ t('Status') }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(row, index) in history" :key="index">
                    <td>{{ row.date }}</td>
                    <td>{{ typeLabel(row.type) }}</td>
                    <td>{{ row.date_start ? row.date_start + ' – ' + row.date_end : '—' }}</td>
                    <td>{{ row.total !== null ? $options.filters.currency(row.total) : '—' }}</td>
                    <td>
                      <router-link v-if="row.status == 'pending' && row.order.id" :to="'/tripteev/order/' + row.order.id" class="badge badge-soft-danger font-size-12 text-uppercase">{{ statusLabel(row.status) }}</router-link>
                      <span v-else class="badge badge-soft-success font-size-12 text-uppercase">{{ statusLabel(row.status) }}</span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <!-- Perguntas frequentes -->
          <div v-if="isIntro" class="tripteev-faq">
            <h5>{{ t('Frequently asked questions') }}</h5>
            <details>
              <summary>{{ t('How long does it take to activate my access?') }}</summary>
              <p>{{ t('Right after the payment is confirmed. With PIX and credit card, activation happens within a few minutes.') }}</p>
            </details>
            <details>
              <summary>{{ t('How long does each payment last?') }}</summary>
              <p>{{ t('Membership and each monthly fee release 30 days of access. If you pay in advance, the new period starts the day after the current one ends.') }}</p>
            </details>
            <details>
              <summary>{{ t('What if I pay after the due date?') }}</summary>
              <p>{{ t('Your access is reactivated for 30 days from the payment date. Membership is not charged again.') }}</p>
            </details>
            <details>
              <summary>{{ t('I generated the invoice and want to cancel it. What now?') }}</summary>
              <p>{{ t('While the invoice has no payment, you can cancel it on this page. It expires automatically in 3 days.') }}</p>
            </details>
          </div>
        </div>
      </main>
    </div>

  </Layout>
</template>
